import * as R from 'ramda'
import { User } from '../stores'

// @dynamic
export function isEmailTaken(email: string, users: User[]) {
  return R.any((r: User) => r.primaryEmail === email)(users) ? { emailTaken: true } : null
}
